import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'translate';
import styled from 'styled-components';
import LanguageSelect from './LanguageSelect';

import MenuItem from './MenuItem';

import ClipImg from '../_common/ClipImg';

import SupportIcon from './SupportIcon';
import Initials from '../_common/Initials';
import { colors } from '../../styles/_vars';

const SubMenuControl = styled.span`
  .business-name {
    white-space: normal;
    max-width: 125px;
  }
  
  .page-img {
    position: relative;
    overflow: hidden;
    border: none;
    
    &::after {
      content: '';
      width: 28px;
      height: 28px;
      border: 1px solid ${colors.white};
      border-radius: 5px;
      position: absolute;
      top: 0;
      left: 0;
    }
    
    img {
      width: 56.25px;
      height: 37.5px;
      opacity: 1;
    }
  }
`;

const PagesMenu = ({
  visible, isAuthenticated, business = {}, businessesCount,
  onMenuClose, onImagesClick,
  onSwitchBusinessPersonal, onLoginClick, /* onLogoutClick,*/ isMobile, onStartCampaignClick,
  onSupportClick,
}) => (
  <div
    className={`Menu ${(visible) ? 'show' : ''} ${isMobile ? 'mobile' : ''}`}
    id="offCanvasMenu"
  >
    {/* <LanguageSwitcher/>*/}
    <ul className="nav business flex-column">
      <li className="nav-item page">
        <MenuItem onClick={onMenuClose} to={`/page/${business.handle}`}>
          <SubMenuControl className="sub-menu-control">
            {business.profile_media_url ?
              <ClipImg
                className="page-img"
                style={{ width: 28, height: 28 }}
                imageStyles={{
                  width: 'unset', height: 28, marginTop: 0, marginLeft: 0, objectFit: 'cover',
                }}
                src={business.profile_media_url}
                x1={business.profile_x1}
                x2={business.profile_x2}
                y1={business.profile_y1}
                y2={business.profile_y2}
              />
              : <div className="initials-wrapper"><Initials name={business.name} /></div>}
            {/* <span className="business-name">{business.name}</span>*/}
            <FormattedMessage id="main.page" tagName="span" />
          </SubMenuControl>
        </MenuItem>
      </li>
      {/* Business Section*/}
      {isAuthenticated && businessesCount && (
        <MenuItem
          onClick={onMenuClose}
          to={`/page/${business.handle}/dashboard`}
          icon="activity"
          disabled={!business.handle}
        >
          <FormattedMessage id="main.dashboard" />
        </MenuItem>
      )}
      {isAuthenticated && businessesCount && (
        <MenuItem
          onClick={onMenuClose}
          to={`/page/${business.handle}/audience`}
          icon="audience"
          disabled={!business.handle}
        >
          <FormattedMessage id="main_menu.audiences" />
        </MenuItem>
      )}
      {isAuthenticated && businessesCount && (
        <MenuItem onClick={onImagesClick} icon="images" disabled={!business.handle}>
          <FormattedMessage id="main.media" />
        </MenuItem>
      )}
      {isAuthenticated && businessesCount && (
        <MenuItem
          onClick={onMenuClose}
          to={`/page/${business.handle}/settings`}
          icon="settings"
          disabled={!business.handle}
        >
          <FormattedMessage id="main.settings" />
        </MenuItem>
      )}
      {isAuthenticated && (
        <MenuItem className="support" onClick={onSupportClick} svg={SupportIcon}>
          <FormattedMessage id="main.support" />
        </MenuItem>
      )}
      {isAuthenticated && businessesCount && (
        <MenuItem onClick={onStartCampaignClick} icon="rocket">
          <FormattedMessage id="main.create_a_smartlink" />
        </MenuItem>
      )}
      {/* isAuthenticated && businessesCount && (
        <MenuItem onClick={onMenuClose} to={`/page/${business.handle}/settings`} icon="gramophone">
          <FormattedMessage id="" />
        </MenuItem>
      ) */}
      <li className="menu-border" />
      {/* General Links */}
      {isAuthenticated ? (
        <MenuItem
          onClick={onSwitchBusinessPersonal}
          icon="personal"
        >
          <FormattedMessage id="main_menu.switch_to_personal" />
        </MenuItem>
      ) : null}
      <MenuItem onClick={onMenuClose} href="https://help.2key.io/en/" icon="faq">
        <FormattedMessage id="main_menu.faq" />
      </MenuItem>
      <MenuItem onClick={onMenuClose} href="https://medium.com/2key" icon="blog">
        <FormattedMessage id="main_menu.blog" />
      </MenuItem>
      <MenuItem
        className="newBusiness"
        onClick={onMenuClose}
        href="https://www.2key.network"
        icon="about"
      >
        <FormattedMessage id="main.about_2key" />
      </MenuItem>
      {!isAuthenticated && (
        <MenuItem onClick={onLoginClick} >
          <FormattedMessage id="main.login" />
        </MenuItem>
      )}
      {/* isAuthenticated && (
        <React.Fragment>
          <li className="menu-border" />
          <MenuItem
            className="newBusiness"
            onClick={onMenuClose}
            href="https://test.2key.io/"
            icon="about"
            disabled
          >
            <FormattedMessage id="" />
            &nbsp;
            {(window.CONFIG.mainNet > 1) &&
              <React.Fragment>
                {'('}
                <FormattedMessage id="" />
                {')'}
              </React.Fragment>}
          </MenuItem>
        </React.Fragment>
      )*/}
      <li className="menu-border" />
      <MenuItem
        className="switch-network"
        onClick={onMenuClose}
        href={`//${(window.CONFIG.mainNet > 1) ? '2key.io' : 'test.2key.io'}`}
      >
        <div className="switch-network__icon">
          {/* eslint-disable-next-line max-len */}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62.28 62.28"><path d="M58.14,39.27a27.36,27.36,0,0,0-12.6-28.56,2.46,2.46,0,0,0-1.89-.3,2.49,2.49,0,0,0-1.56,1.12,2.52,2.52,0,0,0-.3,1.9A2.49,2.49,0,0,0,42.91,15,22.32,22.32,0,0,1,53.35,37.64h-.21a8.51,8.51,0,1,0,5,1.63Zm-5,10.37a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,53.14,49.64Zm-13.4,5.29h0a22.1,22.1,0,0,1-8.59,1.71,22.63,22.63,0,0,1-15-5.72,8.5,8.5,0,1,0-7,3.72,8.7,8.7,0,0,0,3.07-.57,27.66,27.66,0,0,0,18.93,7.57,27.33,27.33,0,0,0,10.51-2.08,2.5,2.5,0,0,0-1.91-4.63ZM9.14,42.64a3.5,3.5,0,1,1-3.5,3.5A3.5,3.5,0,0,1,9.14,42.64ZM6,34.85h.18a2.52,2.52,0,0,0,2.5-2.32A22.21,22.21,0,0,1,23.56,13a8.49,8.49,0,1,0-.84-5,27.51,27.51,0,0,0-19,24.2A2.5,2.5,0,0,0,6,34.85ZM31.14,5.64a3.5,3.5,0,1,1-3.5,3.5A3.5,3.5,0,0,1,31.14,5.64Z" /></svg>
        </div>
        <div className="switch-network__text">
          {(window.CONFIG.mainNet > 1) ?
            <FormattedMessage id="main_menu.open_main_net" /> :
            <FormattedMessage id="main_menu.open_test_net" />}
        </div>
      </MenuItem>
    </ul>

    <LanguageSelect />
  </div>
);

PagesMenu.propTypes = {
  isMobile: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  business: PropTypes.object,
  businessesCount: PropTypes.bool,
  visible: PropTypes.bool,
  onMenuClose: PropTypes.func.isRequired,
  onSwitchBusinessPersonal: PropTypes.func.isRequired,
  onStartCampaignClick: PropTypes.func.isRequired,
  onImagesClick: PropTypes.func.isRequired,
  onLoginClick: PropTypes.func.isRequired,
  onSupportClick: PropTypes.func.isRequired,
  // onLogoutClick: PropTypes.func.isRequired,
};

export default PagesMenu;
